import Header from "../header/Header";
import { useTranslation } from "react-i18next";
import { services } from "../../data";
import "./inner.scss";
import Footer from "../footer/footer";
import Mobilecontact from "../../helper/mobilecontact";
import Hero from "../Hero/Hero";

const Inner = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <Hero />
      <main className="container">
        <div className="left-side"></div>
        <div className="middle-side">
          <h1 className="hero-title">{t("hero_title")}</h1>
          <h2 className="services-title">{t("header2")}</h2>
          <div className="service">
            {services.map((service, index) => (
              <div key={index} className="services-container">
                <img
                  className="service-img"
                  src={service.img}
                  alt={t(service.name)}
                  loading="lazy"
                />
                <div className="service-name-container">
                  <h3 className="service-name">{t(service.name)}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="right-side"></div>
      </main>
      <Mobilecontact />
      <Footer />
    </>
  );
};

export default Inner;
